import ImageClass from "../../src/shell/Image";
import { jump } from "../../src/shell/jump";
import { angela } from "../characters/Angela";
import { customer } from "../characters/Customer";
import { mc } from "../characters/MC";
import { tom } from "../characters/Tom";
import { vanessa } from "../characters/Vanessa";
import { doTransition, doWaitImageByTime } from "../helpers/helpers";
import { images } from "./images";
import { V8VanessaMCCoffeeAfter } from "./V8";

export const V8VanessaMCCoffee = async (): Promise<any> => {
    // Looking through the window
    doTransition(images.v8.V8VanessaMCCustomerCoffee_0);
    mc.talk(`I'm here, what's going on?`);
    ImageClass.setImage(images.v8.V8VanessaMCCustomerCoffee_1);
    vanessa.talk(`I think we just hit the jackpot!`);
    ImageClass.setImage(images.v8.V8VanessaMCCustomerCoffee_1.partials.V8VanessaMCCustomerCoffee_2);
    mc.talk(`Wow, you are right, he is not alone.`);
    mc.talk(`Who do you think they are?`);

    // Turning to the MC
    ImageClass.setImage(images.v8.V8VanessaMCCustomerCoffee_1);
    vanessa.talk(`Our grandpa might be an actual grandpa!`);
    ImageClass.setImage(images.v8.V8VanessaMCCustomerCoffee_1.partials.V8VanessaMCCustomerCoffee_2);
    mc.talk(`You think? She could be his daughter, or just some random girl... Like you.`);
    ImageClass.setImage(images.v8.V8VanessaMCCustomerCoffee_1);
    vanessa.talk(`First of all I'm not RANDOM.`);
    vanessa.talk(`Second, his daughter would have been older, he is like two hundred!`);
    ImageClass.setImage(images.v8.V8VanessaMCCustomerCoffee_1.partials.V8VanessaMCCustomerCoffee_2);
    mc.talk(`From here we can only guess.`);
    ImageClass.setImage(images.v8.V8VanessaMCCustomerCoffee_1);
    vanessa.talk(`Exactly! Follow me.`);
    mc.talk(`What are you planning?`);
    doWaitImageByTime(images.v8.V8VanessaMCCustomerCoffee_3);
    mc.talk(`...`);
    // Vanessa and MC going inside

    // Inside.
    doWaitImageByTime(images.v8.V8VanessaMCCustomerCoffee_4);
    mc.talk(`He hasn't noticed us.`);
    ImageClass.setImage(images.v8.V8VanessaMCCustomerCoffee_4.partials.V8VanessaMCCustomerCoffee_5);
    vanessa.talk(`Shh... Let's listen.`);
    ImageClass.setImage(images.v8.V8VanessaMCCustomerCoffee_6);
    customer.talk(`Darling, I hope you enjoyed your stay here.`);
    ImageClass.setImage(images.v8.V8VanessaMCCustomerCoffee_6.partials.V8VanessaMCCustomerCoffee_6_p);
    angela.talk(`I did grandpa! I had a lot of fun.`);
    ImageClass.setImage(images.v8.V8VanessaMCCustomerCoffee_7.partials.V8VanessaMCCustomerCoffee_8, { putParent: true });
    customer.talk(`And to think you didn't want to come at first.`);
    angela.talk(`I'm glad you convinced me!`);
    ImageClass.setImage(images.v8.V8VanessaMCCustomerCoffee_7);
    customer.talk(`What about you ${tom.name}?`);
    tom.talk(`I had a really good time Mr. Thompson.`);
    await customer.talk(`I'm glad to hear it ${tom.name}.`);
    customer.talk(`It was also very nice to meet you finally. ${angela.name} keeps talking about you over the phone. I just had to meet you in person.`);
    ImageClass.setImage(images.v8.V8VanessaMCCustomerCoffee_6.partials.V8VanessaMCCustomerCoffee_6_p_2, { putParent: true });
    tom.talk(`I'm also glad you meet you Mr. Thompson.`);
    ImageClass.setImage(images.v8.V8VanessaMCCustomerCoffee_6.partials.V8VanessaMCCustomerCoffee_6_p, { putParent: true });
    angela.talk(`So, what are we going to do now?`);
    ImageClass.setImage(images.v8.V8VanessaMCCustomerCoffee_6);
    customer.talk(`Unfortunately, I have to get back to work.`);
    ImageClass.setImage(images.v8.V8VanessaMCCustomerCoffee_6.partials.V8VanessaMCCustomerCoffee_6_p_3);
    angela.talk(`But we have a few more hours before our flight...`);
    customer.talk(`I'm sorry darling. You can go back to the apartment if you want.`);
    angela.talk(`I don't want to spend my last hours here watching TV...`);
    angela.talk(`I was hoping we can go to the beach...`);
    customer.talk(`I'll make it up to you, but I have to go. I'm already late.`);

    // Back to Vanessa
    doWaitImageByTime(images.v8.V8VanessaMCCustomerCoffee_9);
    vanessa.talk(`JACKPOT!`);
    vanessa.talk(`So much info!!!`);
    ImageClass.setImage(images.v8.V8VanessaMCCustomerCoffee_9.partials.V8VanessaMCCustomerCoffee_10);
    vanessa.talk(`I told you she is his granddaughter.`);
    mc.talk(`I agree, that's a shit ton of information.`);
    mc.talk(`But what are we going to do with it?`);
    ImageClass.setImage(images.v8.V8VanessaMCCustomerCoffee_9);
    vanessa.talk(`Stay put!`);
    mc.talk(`Vanessa? What are you pla-`);
    // Vanessa goes over.
    // FIXME: fix the spoon
    doWaitImageByTime(images.v8.V8VanessaMCCustomerCoffee_11);
    customer.talk(`Haha. Yes I remember.`);
    doWaitImageByTime(images.v8.V8VanessaMCCustomerCoffee_12);
    vanessa.talk(`Hello Mr. Thompson! It's so nice to see you here again!`);
    customer.talk(`What...?`);
    doWaitImageByTime(images.v8.V8VanessaMCCustomerCoffee_13);
    vanessa.talk(`Is this your granddaughter that you keep mentioning?`);
    vanessa.talk(`It's so nice to finally meet you! I'm Vanessa.`);
    doWaitImageByTime(images.v8.V8VanessaMCCustomerCoffee_14);
    angela.talk(`Hey! I'm ${angela.name}.`);
    ImageClass.setImage(images.v8.V8VanessaMCCustomerCoffee_13);
    vanessa.talk(`Your grandfather is one of the nicest people I've met!`);
    ImageClass.setImage(images.v8.V8VanessaMCCustomerCoffee_14);
    angela.talk(`I know!`);
    ImageClass.setImage(images.v8.V8VanessaMCCustomerCoffee_14.partials.V8VanessaMCCustomerCoffee_15);
    customer.talk(`Ah... We should get going now.`);
    // looking at the customer smiling
    ImageClass.setImage(images.v8.V8VanessaMCCustomerCoffee_24);
    vanessa.talk(`Why in such a hurry? I bet ${angela.name} would want to hear how we know each other!`);
    ImageClass.setImage(images.v8.V8VanessaMCCustomerCoffee_25);
    customer.talk(`That's not important.`);
    ImageClass.setImage(images.v8.V8VanessaMCCustomerCoffee_14.partials.V8VanessaMCCustomerCoffee_15, { putParent: true });
    angela.talk(`It is!`);
    ImageClass.setImage(images.v8.V8VanessaMCCustomerCoffee_13.partials.V8VanessaMCCustomerCoffee_13_p, { putParent: true });
    vanessa.talk(`Actually, from here!`);
    vanessa.talk(`I used to work here, and he is a regular customer!`);
    ImageClass.setImage(images.v8.V8VanessaMCCustomerCoffee_14);
    angela.talk(`How nice!`);
    ImageClass.setImage(images.v8.V8VanessaMCCustomerCoffee_13.partials.V8VanessaMCCustomerCoffee_13_p, { putParent: true });
    vanessa.talk(`I know right!`);
    ImageClass.setImage(images.v8.V8VanessaMCCustomerCoffee_14);
    angela.talk(`Why did you quit?`);
    doWaitImageByTime(images.v8.V8VanessaMCCustomerCoffee_13.partials.V8VanessaMCCustomerCoffee_13_p, { putParent: true });
    vanessa.talk(`Well... Funny that you ask!`);
    ImageClass.setImage(images.v8.V8VanessaMCCustomerCoffee_16);
    customer.talk(`She had to leave to focus on college work.`);
    ImageClass.setImage(images.v8.V8VanessaMCCustomerCoffee_14);
    angela.talk(`Oh! What do you study?`);
    // looking at the customer smiling /same one
    ImageClass.setImage(images.v8.V8VanessaMCCustomerCoffee_24);
    vanessa.talk(`The same thing as Mr. Thompson!`);
    ImageClass.setImage(images.v8.V8VanessaMCCustomerCoffee_14);
    angela.talk(`Oh! You are studying law?`);
    ImageClass.setImage(images.v8.V8VanessaMCCustomerCoffee_13.partials.V8VanessaMCCustomerCoffee_13_p, { putParent: true });
    vanessa.talk(`Exactly!`);
    ImageClass.setImage(images.v8.V8VanessaMCCustomerCoffee_16);
    customer.talk(`Well, it was nice seeing you, but it's their last few hours here before their flight and we are trying to catch up on some last minute things.`);
    ImageClass.setImage(images.v8.V8VanessaMCCustomerCoffee_13.partials.V8VanessaMCCustomerCoffee_13_p, { putParent: true });
    vanessa.talk(`How rude of me. I didn't know that I was disturbing you.`);
    ImageClass.setImage(images.v8.V8VanessaMCCustomerCoffee_14);
    angela.talk(`You are not!`);
    ImageClass.setImage(images.v8.V8VanessaMCCustomerCoffee_13.partials.V8VanessaMCCustomerCoffee_13_p, { putParent: true });
    vanessa.talk(`Great! Because I don't have plans right now anyway.`);
    ImageClass.setImage(images.v8.V8VanessaMCCustomerCoffee_14);
    angela.talk(`Haha, either do we! We have a few more hours to burn before our flight.`);
    //  Luggage
    doWaitImageByTime(images.v8.V8VanessaMCCustomerCoffee_17);
    vanessa.talk(`Yes, I noticed your luggage.`);
    ImageClass.setImage(images.v8.V8VanessaMCCustomerCoffee_13.partials.V8VanessaMCCustomerCoffee_13_p, { putParent: true });
    vanessa.talk(`You know what? I have a great idea!`);
    vanessa.talk(`Maybe I can show you some cool new places before you leave!`);
    vanessa.talk(`Trust me, I know the best spots around here.`);

    ImageClass.setImage(images.v8.V8VanessaMCCustomerCoffee_14);
    angela.talk(`Really? That's sounds great! I was kinda bummed I have to spend my last hours sitting here in this coffee shop.`);
    angela.talk(`I was hoping we could go to the beach.`);
    angela.talk(`Do you happened to know a good spot?`);
    ImageClass.setImage(images.v8.V8VanessaMCCustomerCoffee_13.partials.V8VanessaMCCustomerCoffee_13_p, { putParent: true });
    vanessa.talk(`I know a great spot!`);
    ImageClass.setImage(images.v8.V8VanessaMCCustomerCoffee_16);
    customer.talk(`Absolutely not!`);
    doWaitImageByTime(images.v8.V8VanessaMCCustomerCoffee_18);
    angela.talk(`Why not? It's not like she is a stranger.`);
    ImageClass.setImage(images.v8.V8VanessaMCCustomerCoffee_16);
    customer.talk(`I'll rather know you are safe.`);
    doWaitImageByTime(images.v8.V8VanessaMCCustomerCoffee_18);
    angela.talk(`Why wouldn't I be safe?`);
    angela.talk(`Besides, I'm not a child anymore! You said it yourself on my eighteenth birthday!`);

    ImageClass.setImage(images.v8.V8VanessaMCCustomerCoffee_24);
    vanessa.talk(`Come on Mr. Thompson. Let them enjoy their last hours here before they leave!`);
    ImageClass.setImage(images.v8.V8VanessaMCCustomerCoffee_13.partials.V8VanessaMCCustomerCoffee_20, { putParent: true });
    vanessa.talk(`Besides, it's not like it's just me. My boyfriend will also be joining us. He is right over there.`);
    doWaitImageByTime(images.v8.V8VanessaMCCustomerCoffee_19);
    angela.talk(`Hey!!!`, { method: "Shouting" });

    ImageClass.setImage(images.v8.V8VanessaMCCustomerCoffee_16);
    customer.talk(`You are staying here and that's final!`);
    // Vanessa gets up.
    ImageClass.setImage(images.v8.V8VanessaMCCustomerCoffee_13);
    vanessa.talk(`It seems like the choice is made...`);
    doWaitImageByTime(images.v8.V8VanessaMCCustomerCoffee_22);
    vanessa.talk(`Too bad... It could have been fun.`);
    doWaitImageByTime(images.v8.V8VanessaMCCustomerCoffee_23);
    angela.talk(`I'm going!`);
    doWaitImageByTime(images.v8.V8VanessaMCCustomerCoffee_22);
    vanessa.talk(`Great! Let's go!`);





    return jump(V8VanessaMCCoffeeAfter, "V8VanessaMCCoffeeAfter");
};